export default "__VITE_ASSET__BjUfGVc5__"